import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-link-about-bgt',
    templateUrl: './link-about-bgt.component.html',
    styleUrls: ['./link-about-bgt.component.scss'],
    imports: [RouterLink]
})
export class LinkAboutBgtComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
